import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';

const GET_DYNAMIC_NEWSLETTER = gql`
  query GetDynamicNewsletter($visitorId: String!, $fallbackNewsletter: String) {
    getDynamicNewsletter(
      visitorId: $visitorId
      fallbackNewsletter: $fallbackNewsletter
    ) {
      dynamicNewsletterName
    }
  }
`;

/**
 * Apollo request
 */
const getDynamicNewsletterQuery = async ({ variables }) => {
  try {
    const statement = await query({
      query: GET_DYNAMIC_NEWSLETTER,
      variables,
    });

    return statement.data.getDynamicNewsletter.dynamicNewsletterName;
  } catch (error) {
    throw new Error('Could not get a dynamic newsletter');
  }
};

export default getDynamicNewsletterQuery;
